<template>
  <b-modal hide-footer id="settings-modal" title="Settings">

      <b-form-checkbox v-model="shouldLoadIncompleteTasks">
        Show incomplete tasks with no agent assigned on tickets page?
      </b-form-checkbox>

      <div class="form-group mt-4">
        <label for="highlightTicketsWithNoCommunicationSince">
          Highlight tickets with no communication since
        </label>
        <select v-model="highlightTicketsWithNoCommunicationSince" class="form-control" id="highlightTicketsWithNoCommunicationSince">
          <option :value="null">Don't highlight any tickets</option>
          <option :value="0.5">30 minutes</option>
          <option :value="1">1 hour</option>
          <option :value="2">2 hours</option>
          <option :value="3">3 hours</option>
          <option :value="4">4 hours</option>
          <option :value="5">5 hours</option>
          <option :value="6">6 hours</option>
          <option :value="7">7 hours</option>
          <option :value="8">8 hours</option>
          <option :value="9">9 hours</option>
          <option :value="10">10 hours</option>
          <option :value="11">11 hours</option>
          <option :value="12">12 hours</option>
          <option :value="24">24 hours</option>
          <option :value="36">36 hours</option>
          <option :value="48">48 hours</option>
        </select>
      </div>

      <div class="form-group mt-4">
        <label for="openTicketInSameWindow">
          Open new tickets
        </label>
        <select v-model="openTicketInSameWindow" class="form-control" id="openTicketInSameWindow">
          <option :value="true">Open in same tab</option>
          <option :value="false">Open in new tab</option>
        </select>
      </div>

  </b-modal>
</template>

<script>
export default {
  name: "SelectTimezoneModal",
  data() {
    return {
      shouldLoadIncompleteTasks: false,
      highlightTicketsWithNoCommunicationSince: null,
      openTicketInSameWindow: true,

      shouldSave: false
    }
  },
  created() {
    let vm = this;

    this.shouldLoadIncompleteTasks = window.itgShouldLoadIncompleteTasks;
    this.highlightTicketsWithNoCommunicationSince = window.itgHighlightTicketsWithNoCommunicationSince;
    this.openTicketInSameWindow = Boolean(window.itgOpenTicketInSameWindow);

    this.$nextTick(() => {
      vm.shouldSave = true;
    });
  },
  watch: {
    shouldLoadIncompleteTasks: function (val) {
      if (this.shouldSave) {
        window.itgShouldLoadIncompleteTasks = val;
        localStorage.setItem('itgShouldLoadIncompleteTasks', val);
      }
    },

    highlightTicketsWithNoCommunicationSince: function (val) {
      if (this.shouldSave) {
        window.itgHighlightTicketsWithNoCommunicationSince = val;
        localStorage.setItem('itgHighlightTicketsWithNoCommunicationSince', val);
      }
    },

    openTicketInSameWindow: function (val) {
      if (this.shouldSave) {
        window.itgOpenTicketInSameWindow = val;
        localStorage.setItem('itgOpenTicketInSameWindow', Boolean(val));
      }
    }
  },
  computed: {},
  methods: {
    setTimezone(timezone) {
      window.itgTimezone = timezone;
      localStorage.setItem('itgTimezone', timezone);
      this.timezone = timezone;
      this.$bvModal.hide('select-timezone-modal');
      this.$notify.success({
        title: 'Success!',
        message: 'Timezone updated successfully'
      });
      window.location.reload();
    },

    isTimezoneSelected(tz) {
      return this.timezone === tz;
    }
  }
}
</script>

<style>
.timezones-table {
  max-height: 450px;
  overflow-y: scroll;
}
</style>